// extracted by mini-css-extract-plugin
export var button = "styles-module--button--07f2c";
export var disabled = "styles-module--disabled--337df";
export var left = "styles-module--left--d6826";
export var right = "styles-module--right--4ed16";